import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BaseTabsComponent } from '../base-tabs/base-tabs.component';

@Component({
  selector: 'app-vertical-tabs',
  templateUrl: './vertical-tabs.component.html',
  styleUrls: ['./vertical-tabs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerticalTabsComponent extends BaseTabsComponent implements OnChanges, OnInit {
  @Input()
  useAsRouterLink: boolean;

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
